import classnames from 'classnames/bind';
import styles from './AtrributeFields.module.scss';
import { UseFormRegister } from 'react-hook-form';
import { Dispatch, SetStateAction } from 'react';
import { ImageUpload, Input } from '@weareopenr/component-library';

const cx = classnames.bind(styles);

export const AttributeFields = ({
  register,
  image,
  setImage,
  placeholders,
}: {
  register: UseFormRegister<any>;
  image: string | File;
  setImage: Dispatch<SetStateAction<string | File>>;
  placeholders: {
    consumer_name?: string;
    description?: string;
    posId?: string;
  };
}) => {
  return (
    <>
      <div className={cx('input-container')}>
        <Input
          register={register('consumerName')}
          type="text"
          label="Consumer Name"
          placeholder={placeholders.consumer_name || undefined}
        />
        <Input
          register={register('description')}
          type="text"
          label="Description"
          rows={3}
          placeholder={placeholders.description || undefined}
        />
        <Input register={register('plu')} type="text" label="POS ID" placeholder={placeholders.posId || undefined} />
      </div>
      <ImageUpload prompt="Upload Image" image={image} setImage={setImage} />
    </>
  );
};
